// 한글 이름 뒤 조사는 화면마다 다시 계산하지 않는다. 문자열을 붙이는 자리가 둘로 갈리면
// 같은 이름이 한 화면에서는 "지원가", 다른 화면에서는 "지원이"가 되는 회귀가 난다.
const HANGUL_FIRST = 0xac00;
const HANGUL_LAST = 0xd7a3;
const JONGSEONG_L = 8;

/* 숫자는 읽는 소리의 받침을 따른다 — 「v2이 기록됐습니다」(E-30)는 2(이)를 받침 있는
 * 글자로 낙관해서 났다. 값은 종성 인덱스다: 영(ㅇ)=21 · 일(ㄹ)=8 · 삼(ㅁ)=16 ·
 * 육(ㄱ)=1 · 칠(ㄹ)=8 · 팔(ㄹ)=8, 나머지(이·사·오·구)는 받침 없음(0). */
const DIGIT_FINAL = { 0: 21, 1: JONGSEONG_L, 2: 0, 3: 16, 4: 0, 5: 0, 6: 1, 7: JONGSEONG_L, 8: JONGSEONG_L, 9: 0 };

function finalConsonant(text) {
  const last = [...String(text ?? '').trim()].at(-1);
  const code = last?.codePointAt(0);
  if (code === undefined) return null;
  if (last >= '0' && last <= '9') return DIGIT_FINAL[last];
  if (code < HANGUL_FIRST || code > HANGUL_LAST) return null;
  return (code - HANGUL_FIRST) % 28;
}

/** `kind`: subject(이/가), topic(은/는), direction(으로/로). */
export function withParticle(value, kind) {
  const text = String(value ?? '').trim();
  const jong = finalConsonant(text);

  if (kind === 'subject') {
    if (text === '나') return '내가';
    if (text === '너') return '네가';
    return `${text}${jong ? '이' : '가'}`;
  }
  if (kind === 'topic') return `${text}${jong ? '은' : '는'}`;
  if (kind === 'direction') return `${text}${jong && jong !== JONGSEONG_L ? '으로' : '로'}`;
  throw new Error(`unknown Korean particle kind: ${kind}`);
}
